export interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
}

// Il banner esiste solo se c'e qualcosa che richiede consenso (oggi: Google
// Analytics). Plausible e i cookie tecnici non lo richiedono.
export const HAS_CONSENT_TOOLS = Boolean(
  process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
);

export const COOKIE_CONSENT_KEY = "cookie_consent";
export const COOKIE_PREFERENCES_KEY = "cookie_preferences";

export function readCookiePreferences(): CookiePreferences | null {
  const prefs = localStorage.getItem(COOKIE_PREFERENCES_KEY);
  if (!prefs) return null;

  try {
    return JSON.parse(prefs) as CookiePreferences;
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent(): boolean {
  return readCookiePreferences()?.analytics ?? false;
}

export function hasMarketingConsent(): boolean {
  return readCookiePreferences()?.marketing ?? false;
}
